$(document).ready(function () {
    var trigger = $('.hamburger'),
        overlay = $('.overlay'),
        centroDiv=$('#centro-div'),
        isClosed = false;


    trigger.click(function () {
        hamburger_cross();
    });
    function hamburger_cross() {

        if (isClosed == true) {
            console.log('Cerrado');

            centroDiv.animate({
                width:'97%'
            },400);

            trigger.removeClass('is-open');
            trigger.addClass('is-closed');
            isClosed = false;
        } else {

            centroDiv.animate({
                width:'85.7%'
            },400);

            trigger.removeClass('is-closed');
            trigger.addClass('is-open');
            isClosed = true;
        }
    }

    $('[data-toggle="offcanvas"]').click(function () {
        $('#wrapper').toggleClass('toggled');
    });
    hamburger_cross();
    $('#wrapper').toggleClass('toggled');

});